import 'react';
import { useComponentFrameworkState } from '@provider/component-framework';
import { Drawer } from '@ui/kit';
import { CompactDotsIcon } from '@ui/kit/icons';
import { ComponentFrameworkContextMenu } from '@utils/component-framework';
import { useToggleState, IsomorphicPortal } from '@utils/react';
import { IArkContextMenu } from '../../root.component/integration.context-menu.js';
import { IArkRetryButton } from '../../root.component/modal.retry.js';
import { Button } from './atom.button.js';
import { drawer, content } from './tool.context-menu.style.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function ContextMenuTool(props) {
  const targetSelector = useComponentFrameworkState(state => state.overlayContainerSelector);
  const target = targetSelector && document.querySelector(targetSelector) || undefined;
  const [open, actions] = useToggleState();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Button, {
      tooltip: "\xC5bn kontekstmenu",
      onClick: actions.enable,
      children: /*#__PURE__*/jsx(CompactDotsIcon, {
        width: 20
      })
    }), /*#__PURE__*/jsx(IsomorphicPortal, {
      target: target,
      children: /*#__PURE__*/jsx(Drawer, {
        className: drawer,
        active: open,
        onClose: actions.disable,
        explicitKey: "contextmenu",
        disableBackdrop: true,
        children: /*#__PURE__*/jsx("div", {
          className: content,
          children: /*#__PURE__*/jsx(IArkContextMenu, {
            layout: "solid",
            targetRef: props.rootRef,
            component: props.node.component,
            context: props.context,
            onShareWithTeacher: props.onShareWithTeacher,
            onButtonClicked: actions.disable,
            children: /*#__PURE__*/jsx(ComponentFrameworkContextMenu.Button, {
              type: "extra",
              children: /*#__PURE__*/jsx(IArkRetryButton, {
                context: "contextmenu",
                onClick: actions.disable
              })
            })
          })
        })
      })
    })]
  });
}

export { ContextMenuTool };
//# sourceMappingURL=tool.context-menu.js.map
